module.exports = __webpack_public_path__ + "static/media/file.07e6c32a.png";